import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import { useDocCategoryContext } from "../../../context/DocumentCategoryContext/DocumentCategoryContext";
import InputNumberComponent from "../../../components/InputNumberComponent";

const Info = () => {
	const { docCategoryForm, setDocCategoryForm } = useDocCategoryContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={5}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder="1"
						positiveOnly
						value={docCategoryForm?.categoryNo}
						onChange={(value) => setDocCategoryForm({ ...docCategoryForm, categoryNo: Number(value) })}
					/>
				</Col>
				<Col span={15}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder="Tamim"
						isRequired
						value={docCategoryForm?.categoryName}
						onChange={(e) => setDocCategoryForm({ ...docCategoryForm, categoryName: e.target.value })}
					/>
				</Col>
			</Row >
		</>
	);
};

export default Info;
